// test2144
(2144 && 0);
